module.exports = __webpack_public_path__ + "img/confirm.95399993.svg";